var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapRightLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_3990)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 36,
    r: 18,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9167 36.6501H47.4838L45.4726 38.697C45.3826 38.7816 45.3106 38.8834 45.2609 38.9965C45.2113 39.1096 45.185 39.2315 45.1836 39.355C45.1823 39.4785 45.2059 39.601 45.253 39.7151C45.3002 39.8293 45.3699 39.9327 45.458 40.0192C45.5462 40.1057 45.6509 40.1736 45.7658 40.2186C45.8808 40.2636 46.0037 40.285 46.1272 40.2814C46.2506 40.2777 46.3721 40.2492 46.4842 40.1975C46.5963 40.1457 46.6969 40.0719 46.7798 39.9803L48.8322 37.8913C48.9816 37.7418 49.1906 37.5127 49.4042 37.2725C49.7877 36.8388 49.9994 36.2798 49.9994 35.7009C49.9994 35.1219 49.7877 34.563 49.4042 34.1293C49.1906 33.8882 48.9816 33.659 48.8377 33.5151L46.7798 31.4251C46.6072 31.263 46.3787 31.174 46.142 31.1766C45.9053 31.1792 45.6788 31.2732 45.5099 31.4391C45.341 31.6049 45.2428 31.8296 45.2358 32.0662C45.2289 32.3028 45.3137 32.533 45.4726 32.7084L47.536 34.8076L47.5433 34.8168H28.9167C28.6736 34.8168 28.4404 34.9133 28.2685 35.0852C28.0966 35.2572 28 35.4903 28 35.7334C28 35.9765 28.0966 36.2097 28.2685 36.3816C28.4404 36.5535 28.6736 36.6501 28.9167 36.6501Z",
    fill: "#2550AC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_3990",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_3990"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_3990",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapRightLine);
export default __webpack_public_path__ + "static/media/swap-right-line.fe5f48ac8d2e29cfab11543cf1856fc8.svg";
export { ForwardRef as ReactComponent };